import { render, staticRenderFns } from "./PhysicalNetworksTab.vue?vue&type=template&id=1c8e500c&scoped=true&"
import script from "./PhysicalNetworksTab.vue?vue&type=script&lang=js&"
export * from "./PhysicalNetworksTab.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalNetworksTab.vue?vue&type=style&index=0&id=1c8e500c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8e500c",
  null
  
)

export default component.exports